import styled, { css } from 'styled-components';
import media from 'client/styles/media';

const HeaderLogoImgSmall = styled.img`
  height: 34px;
  width: auto;
  margin-top: 8px;
  margin-bottom: 8px;
`;

const HeaderLogoImgLarge = styled.img`
  height: 47px;
  width: 35px;
`;

const HeaderLogoText = styled.div`
  margin-left: 15px;

  ${({ theme }) => theme.logo.font}
  font-size: 34px;
  color: ${({ theme }) => theme.logo.color};
`;

const HeaderLogo = styled.div`
  margin-right: 15px;
  ${media.md} {
    margin-right: initial;
    text-align: center;
  }

  display: flex;
  justify-content: center;
  align-items: center;
`;

const headerLinkTextStyle = css`
  color: #777;
  text-decoration: none;
  &:hover,
  &:focus {
    color: #333;
    text-decoration: none;
  }
`;

const HeaderIconButton = styled.i`
  ${headerLinkTextStyle}
`;

const HeaderLink = styled.div`
  > a {
    display: block;
    padding: 13px;
    text-align: center;
    ${headerLinkTextStyle}
  }
`;

const HeaderProfile = styled.div`
  flex-shrink: 0;
  margin-left: 13px;
  margin-right: 24px;
  @media screen and (max-width: 767px) {
    margin-right: 0px;
  }

  > a {
    display: block;
    > * {
      display: inline-block;
      vertical-align: middle;
    }
    ${headerLinkTextStyle}
  }
`;

const HeaderProfileUserPic = styled.div`
  background-position: center;
  background-size: cover;
  background-color: ${({ theme }) => theme.color.fake};
  border-radius: 50%;

  height: 34px;
  width: 34px;

  ${media.md} {
    height: 46px;
    width: 46px;
  }
`;

const HeaderProfileUserName = styled.div`
  margin-left: 7px;
`;

const HeaderSpacer = styled.div``;

const Header = styled.nav<{ transparent?: boolean }>`
  width: 100%;
  ${({ transparent }) =>
    !transparent &&
    css`
      background-color: ${({ theme }) => theme.color.headerBackground};
      box-shadow: ${({ theme }) => theme.shadow.header};
    `}
  position: relative;
  z-index: 10;

  padding-left: 15px;
  padding-right: 15px;

  display: flex;
  align-items: center;

  > * {
    flex: 0 1 auto;
  }

  > ${HeaderSpacer} {
    flex: 1 0.5 auto;
  }

  ${media.md} {
    height: ${({ theme }) => theme.header.heightDesktop};

    > ${HeaderLogo} {
      flex-basis: 280px;
    }
  }

  @media screen and (max-width: 991px) {
    .large {
      display: none !important;
    }
  }

  @media screen and (min-width: 992px) {
    .small {
      display: none !important;
    }
  }
`;

export {
  Header,
  HeaderLogo,
  HeaderLogoImgSmall,
  HeaderLogoImgLarge,
  HeaderLogoText,
  HeaderLink,
  HeaderSpacer,
  HeaderProfile,
  HeaderProfileUserPic,
  HeaderProfileUserName,
  HeaderIconButton,
};
